import { Inject, Injectable } from '@angular/core';
import { literalConstant } from '../../shared/constant/literal.constant';
import { HttpClient } from '@angular/common/http';
import { FooterModel } from '../model/layout/footer/footer.model';
@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  constructor(
    private http: HttpClient,
    @Inject(literalConstant.API_URL) private baseUrl: string
  ) {}
  public getLayoutFooterDetails() {
    const url: string = this.baseUrl + 'Layout/GetLayoutFooterDetails';
    return this.http.get<FooterModel>(url);
  }
}
